export const DASHBOARD_DEFAULT_PAGE_SIZE = 50;

export function withDashboardPaginationDefaults(search: Record<string, unknown>): Record<string, unknown> {
  return {
    ...search,
    perPage: search.perPage ?? DASHBOARD_DEFAULT_PAGE_SIZE,
    query: typeof search.query === "number" ? String(search.query) : search.query,
    // TanStack Router may deserialize JSON query values before Zod sees them.
    // Keep table sorting serialized so nuqs and URLSearchParams receive a primitive.
    sort: Array.isArray(search.sort) ? JSON.stringify(search.sort) : search.sort,
  };
}
